<div class="p-5">
	<h2 class="m-4 text-2xl font-bold">Transacciones Binance</h2>
	<form (ngSubmit)="applyFilters()" class="flex flex-wrap items-center gap-4 bg-gray-100 p-4 rounded-lg shadow-md md:flex-row flex-col mb-4">
		<mat-form-field appearance="outline" class="modern-field w-full md:w-1/4">
			<mat-label>TxId</mat-label>
			<input matInput [(ngModel)]="filters.txId" name="txId" placeholder="TxId">
		</mat-form-field>
		<mat-form-field appearance="outline" class="modern-field w-full md:w-1/4">
			<mat-label>User ID</mat-label>
			<input matInput [(ngModel)]="filters.userId" name="userId" placeholder="User ID">
		</mat-form-field>
		<mat-form-field appearance="outline" class="modern-field w-full md:w-1/4">
			<mat-label>Coin</mat-label>
			<input matInput [(ngModel)]="filters.coin" name="coin" placeholder="Coin">
		</mat-form-field>
		<mat-form-field appearance="outline" class="modern-field w-full md:w-1/4">
			<mat-label>Address</mat-label>
			<input matInput [(ngModel)]="filters.address" name="address" placeholder="Address">
		</mat-form-field>
		<div class="w-full md:w-auto">
			<button type="submit"
				style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
				onmouseover="this.style.background='#059669'"
				onmouseout="this.style.background='#1C593D'">Buscar</button>
		</div>
	</form>

	<div *ngIf="loading" class="flex justify-center items-center p-4">
		<mat-spinner diameter="40"></mat-spinner>
	</div>
	<div *ngIf="errorMsg" class="error-snackbar">{{ errorMsg }}</div>

	<div class="overflow-auto border rounded-lg shadow-md bg-white">
			<table mat-table [dataSource]="dataSource" class="w-full table-responsive" *ngIf="dataSource">
				<ng-container matColumnDef="txId">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">TxId</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.txId }}</td>
				</ng-container>
				<ng-container matColumnDef="userId">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">UserId</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.userId }}</td>
				</ng-container>
				<ng-container matColumnDef="coin">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Coin</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.coin }}</td>
				</ng-container>
				<ng-container matColumnDef="network">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Network</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.network }}</td>
				</ng-container>
				<ng-container matColumnDef="amount">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Amount</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.amount }}</td>
				</ng-container>
				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Address</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs break-all">{{ dep.address }}</td>
				</ng-container>
				<ng-container matColumnDef="binanceStatus">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">BinanceStatus</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">
						<span [ngClass]="{
							'chip-success': dep.binanceStatus === 'SUCCESS',
							'chip-error': dep.binanceStatus !== 'SUCCESS'
						}">{{ dep.binanceStatus }}</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="internalStatus">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">InternalStatus</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">
						<span [ngClass]="{
							'chip-success': dep.internalStatus === 'abonada' || dep.internalStatus === 'confirmada',
							'chip-warning': dep.internalStatus === 'pendiente' || dep.internalStatus === 'esperando_confirmacion',
							'chip-error': dep.internalStatus === 'rechazado' || dep.internalStatus === 'error_deposito'
						}">{{ dep.internalStatus }}</span>
					</td>
				</ng-container>
				<ng-container matColumnDef="abonada">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Abonada</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.abonada ? 'Si' : 'No' }}</td>
				</ng-container>
				<ng-container matColumnDef="insertTime">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">InsertTime</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.insertTime | date:'short' }}</td>
				</ng-container>
				<ng-container matColumnDef="completeTime">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">CompleteTime</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">{{ dep.completeTime ? (dep.completeTime | date:'short') : '-' }}</td>
				</ng-container>

				<ng-container matColumnDef="acciones">
					<th mat-header-cell *matHeaderCellDef class="bg-aguacate-highlight text-center p-2">Acciones</th>
					<td mat-cell *matCellDef="let dep" class="text-center p-1 text-xs">
						<button *ngIf="puedeAsignar(dep)" type="button" class="btn-asignar" (click)="asignar(dep)">
							Asignar a cliente
						</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			</table>
			<mat-paginator
				[length]="total"
				[pageSize]="pageSize"
				[pageIndex]="pageIndex"
				[pageSizeOptions]="[10, 20, 50]"
				(page)="getDeposits($event)"
				showFirstLastButtons>
			</mat-paginator>
			<div *ngIf="!dataSource.data.length && !loading" class="text-center py-4">No hay transacciones.</div>
		</div>
</div>
